module.exports = __webpack_public_path__ + "img/catA.e8c02d1e.svg";